/**
 * i18n configuration for the ECM application.
 *
 * The authoritative list of supported locales is fetched at runtime from:
 *   `{dataService}/api/v1/locales` (portal.released)
 *
 * The static `SUPPORTED_LOCALES` list below is used only as a fallback
 * when the API is unreachable. It should reflect the minimum set of locales
 * that ECM is expected to support.
 *
 * Each locale entry maps a BCP 47 locale code to a display label
 * shown in the Skylab locale switcher component.
 */

export interface LocaleConfig {
    /** BCP 47 locale code (e.g. "en-US") */
    code: string;
    /** Human-readable display label shown in the locale switcher */
    label: string;
}

/**
 * Fallback locale list used when the `/api/v1/locales` API is unavailable.
 * The first entry is treated as the default locale.
 */
export const SUPPORTED_LOCALES: LocaleConfig[] = [
    { code: "en-US", label: "English (United States)" },
    { code: "fr-CA", label: "Français (Canada)" },
    { code: "es-419", label: "Español (Latinoamérica)" },
];

/** The default locale used when no preference or browser locale matches. */
export const DEFAULT_LOCALE = SUPPORTED_LOCALES[0].code;

/** The set of supported locale codes for fast lookup. */
export const SUPPORTED_LOCALE_CODES = new Set(SUPPORTED_LOCALES.map(l => l.code));
